// src/components/Navigation/HamburgerButton.js
import React from 'react';
import { useGlobal } from '../../context/GlobalContext';
import './HamburgerButton.css';

export function HamburgerButton({ onClick }) {
  const { state } = useGlobal();

  return (
    <button
      className={`hamburger-btn ${state.sidebarOpen ? 'active' : ''}`}
      onClick={onClick}
      aria-label={state.sidebarOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={state.sidebarOpen}
      aria-controls="sidebar-navigation"
    >
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </button>
  );
}